const ITEM_DROP_DOWN = `main-nav__item--drop-down`;
const LIST_DROP = `main-nav__list--drop`;
// const LIST_SUB_DROP = `main-nav__list--subDrop`;
const LIST_SUB_DROP = `main-nav__groupDrop`;
const MAIN_NAV_LIST = `.main-nav__list`;
// const SUB_NAV_LIST = `.main-nav__list--sub`;
const SUB_NAV_LIST = `.main-nav__group`;

const body = document.querySelector(`body`);
const burgerElement = body.querySelector(`.burger`);
const mainNav = body.querySelector(`.main-nav`);
const mainNavElement = body.querySelector(MAIN_NAV_LIST);

mainNav.addEventListener(`scroll`, (evt) => {
  evt.preventDefault;
});

if (mainNavElement) {
  const burgerInner = burgerElement.querySelector(`.burger__inner`);
  burgerElement.addEventListener(`click`, () => {
    mainNav.classList.toggle(`main-nav--block`);
    burgerElement.classList.toggle(`burger--fixed`);
    burgerInner.classList.toggle(`burger__inner--active`);
    mainNavElement.classList.toggle(LIST_DROP);
    // body.classList.toggle(`overflow-hidden`);
  }, true);

  const dropDownList = mainNavElement.querySelectorAll(`.${ITEM_DROP_DOWN}`);

  const showSubMenu = (evt) => {
    closeSubMenu();

    let subMenuElement = ``;
    let menuElement = ``;

    if (evt.target.classList.contains(ITEM_DROP_DOWN)) {
      subMenuElement = evt.target.querySelector(SUB_NAV_LIST);
      menuElement = evt.target;
    } else {
      subMenuElement = evt.target.closest(`.${ITEM_DROP_DOWN}`).querySelector(SUB_NAV_LIST);
      menuElement = evt.target.closest(`.${ITEM_DROP_DOWN}`);
    }
    menuElement.classList.add(`main-nav__item--active`);
    subMenuElement.classList.toggle(LIST_SUB_DROP);
    evt.stopPropagation();
    menuElement.removeEventListener(`click`, showSubMenu, true);
    menuElement.addEventListener(`click`, closeSubMenu);
    document.addEventListener(`click`, closeSubMenu);
  };

  dropDownList.forEach((item) => {
    item.addEventListener(`click`, showSubMenu, true);
  });

  const isSubListOpen = (menuItem) => {
    return menuItem.querySelector(`.${LIST_SUB_DROP}`);
  }

  const closeSubMenu = () => {
    dropDownList.forEach((item) => {
      if (isSubListOpen(item)) {
        item.removeEventListener(`click`, closeSubMenu);
        item.addEventListener(`click`, showSubMenu, true);
        item.classList.remove(`main-nav__item--active`);
      }
    });
    
    const mainNavDropElement = mainNavElement.querySelector(`.${LIST_SUB_DROP}`);
      if (mainNavDropElement) {
        mainNavDropElement.classList.remove(LIST_SUB_DROP);
      }

    document.removeEventListener(`click`, closeSubMenu);
  };
}